// extracted by mini-css-extract-plugin
export default {"iconCopy":"Icon_iconCopy__l+-GZ"};